/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { selectAuthAccountData } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { t } from 'utils/translates';

import {
  changeFieldTimeZone,
  changeFieldConsentToAdultContent,
  selectFieldTimeZone,
  selectFieldConsentToAdultContent,
  selectRequestState,
  sendForm,
  loadFormData
} from 'mt-react-common/modules/users/common/reducers/forms/anketaForm';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';

import SearchSelect from '../../../../Common/Inputs/SearchSelect';
import OpacityPreLoader from '../../../../Common/PreLoaders/OpacityPreLoader';
import DefaultSelect from '../../../../Common/Inputs/DefaultSelect';

const anketaFormRN = 'usersModule.forms.anketaForm';

class TimezoneChoicePopUp extends Component {
  componentDidMount() {
    this.props.loadFormData(this.props.authAccountData.userId);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      this.props.requestState.hasSuccessQuery
    ) {
      this.props.history.push(this.props.location.pathname);
    }
  }
  render() {
    return (
      <div
        className="modal-dialog"
        role="document"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header text-center">
            <a
              aria-label="Close"
              className="close close-black"
              onClick={this.props.handleClose}
              href=""
            />
            <i className="fa fa-address-card-o modal-icon" />
            <h4 className="modal-title">{t('Настройки профиля')}</h4>
            <p>
              {t(
                'Вы всегда можете изменить настройки в {link[label:настройках профиля]}',
                {
                  link: args => (
                    <React.Fragment>
                      <Link to="/main/update-account/anketa">{args.label}</Link>
                    </React.Fragment>
                  )
                }
              )}
            </p>
          </div>
          <form className="pos-rel">
            {this.props.requestState.hasInProgress ? (
              <OpacityPreLoader />
            ) : null}
            <div className="modal-body">
              <div className="form-group ">
                <label className="control-label" htmlFor="title">
                  {t('Часовой пояс')}
                </label>
                <SearchSelect
                  selectArrItems={Object.keys(this.props.timeZones).map(
                    key => ({
                      id: key,
                      title: this.props.timeZones[key]
                    })
                  )}
                  value={this.props.fieldTimeZone.value}
                  handleChangeValue={value => {
                    this.props.changeFieldTimeZone(value);
                  }}
                  placeholder={t('Часовой пояс')}
                />
              </div>
              <div className="form-group">
                <label className="control-label" htmlFor={'0'}>
                  {t('Задания 18+')}
                </label>
                <DefaultSelect
                  selectArrItems={[
                    {
                      value: 0,
                      title: t('Скрывать задания 18+')
                    },
                    {
                      value: 1,
                      title: t('Показывать задания 18+')
                    }
                  ]}
                  selectTitleNullValue={null}
                  value={this.props.fieldConsentToAdultContent.value}
                  handleChangeValue={value => {
                    this.props.changeFieldConsentToAdultContent(value);
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-muted"
                onClick={this.props.handleClose}
                type="button"
              >
                {t('Отмена')}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                onClick={() =>
                  this.props.sendForm(this.props.authAccountData.userId)
                }
              >
                {t('Сохранить')}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

TimezoneChoicePopUp.propTypes = {
  // IN
  handleClose: PropTypes.func.isRequired,

  // withRouter
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,

  // CONNECT STATES
  authAccountData: PropTypes.shape({
    userId: PropTypes.number.isRequired,
    timeZone: PropTypes.string
  }).isRequired,
  fieldTimeZone: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldConsentToAdultContent: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  timeZones: PropTypes.shape({}).isRequired,

  // CONNECT DISPATCH
  sendForm: PropTypes.func.isRequired,
  loadFormData: PropTypes.func.isRequired,
  changeFieldTimeZone: PropTypes.func.isRequired,
  changeFieldConsentToAdultContent: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  authAccountData: selectAuthAccountData(state),
  fieldTimeZone: selectFieldTimeZone(state, anketaFormRN),
  fieldConsentToAdultContent: selectFieldConsentToAdultContent(
    state,
    anketaFormRN
  ),
  requestState: selectRequestState(state, anketaFormRN),
  timeZones: getItemFromRefList(state, 'timeZones')
});

const mapDispatchToProps = dispatch => ({
  loadFormData: userId => dispatch(loadFormData(anketaFormRN, userId)),
  changeFieldTimeZone: value =>
    dispatch(changeFieldTimeZone(anketaFormRN, value)),
  changeFieldConsentToAdultContent: value =>
    dispatch(changeFieldConsentToAdultContent(anketaFormRN, value)),
  sendForm: value => dispatch(sendForm(anketaFormRN, value))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TimezoneChoicePopUp)
);



// WEBPACK FOOTER //
// ./src/components/UserAccount/Confirms/ConfirmNoticeBlocks/TimezoneChoicePopUp/TimezoneChoicePopUp.js